// extracted by mini-css-extract-plugin
module.exports = {"footerList":"styles_footerList__1t0YJ","footerListItem":"styles_footerListItem__21drP"};